<template>
  <v-container fluid>
    <v-row align="center">
      <v-col cols="12">
        <div
          v-if="parkPosition === 'DX'"
          class="text-right"
          :style="`width:${(100 * maxLengthTrue) / maxLengthFactor}%; min-width:${(600 * maxLengthTrue) / maxLengthFactor}px; right: 0px`"
        >
          {{ $t("b") }} {{ binario.numero }}
        </div>
        <div v-else>{{ $t("b") }} {{ binario.numero }}</div>
      </v-col>
    </v-row>
    <v-row class="rail-row" no-gutters id="`binario-${binario.id}`">
      <!--@click="selectingRail"-->
      <div
        class="rail"
        :selected="selectedAttributeValue"
        :style="`width:${(100 * binario.lunghezza) / maxLengthFactor}%; min-width:${(600 * binario.lunghezza) / maxLengthFactor}px; left: ${
          parkPosition === 'DX' ? (100 * (maxLengthTrue - binario.lunghezza)) / maxLengthFactor : 0
        }%`"
        @mousemove="updateMousePosition"
        @mouseleave="hideLine"
        :ref="'container' + binario.numero"
      ></div>

      <Wagon
        v-for="(carroConvoglio, index) in carriConvoglio"
        :deltaBinario="200"
        :active="index === activeIndex"
        :index="index"
        :key="carroConvoglio.id"
        :carroConvoglio="carroConvoglio"
        :maxLengthFactor="maxLengthFactor"
        :utiSearchParam="utiSearchParam"
        :wagonSearchParam="wagonSearchParam"
        :plannedShowing="plannedShowing"
        :features="features"
        :yardShowing="yardShowing"
        :convoglioSel="convoglioSel"
        :numBinario="binario.numero"
        :parkPosition="binario.parcoBinari.posizioneParco"
        :parkPositionWagon="parkPosition"
        :filtered-ships="filteredShips"
        :ship-filter-enabled="shipFilterEnabled"
        :ship-colors="shipColors"
        :isConvoglioInLavorazione="convogliInLavorazione.includes(carroConvoglio.convoglioId)"
        @set-active="activeIndex = $event"
        @updateMousePosition="updateMousePosition"
        @hideLine="hideLine"
      />

      <!-- <LengthMarker :parkPosition="parkPosition" :maxLengthFactor="maxLengthFactor" :maxLengthTrue="maxLengthTrue" :binario="binario" :lengthInterval="lengthInterval"/> -->
    </v-row>
  </v-container>
</template>

<script>
import _ from "lodash";
import multiParkManagementMixins from "../../mixins/MultiParkManagementMixins";
import convoyVisualizationMixins from "./mixins/convoyVisualizationMixins";
import Wagon from "./Wagon";
import LengthMarker from "./LengthMarkerOld.vue";

export default {
  name: "railSpatialVisualization",
  components: {
    Wagon,
    LengthMarker,
  },
  emits: ["mouseMoveOnRail", "lineVisible"],
  props: {
    binario: {
      type: Object,
      required: true,
    },
    maxLengthFactor: {
      type: Number,
      default: 200,
    },
    maxLengthTrue: {
      type: Number,
      default: 200,
    },
    lengthInterval: {
      type: Number,
      default: 10,
    },
    convogli: {
      type: Array,
      default: () => [],
    },
    convoglioSel: {
      type: Object,
      required: false,
    },
    selected: {
      type: Boolean,
      default: false,
    },
    utiSearchParam: {
      type: String,
      default: "",
    },
    wagonSearchParam: {
      type: String,
      default: "",
    },
    plannedShowing: {
      type: Boolean,
      default: false,
    },
    features: {
      type: Array,
      default: () => [],
    },
    yardShowing: {
      type: Boolean,
      default: false,
    },
    parkPosition: {
      type: String,
      default: "SX",
    },
    filteredShips: {
      type: Array,
      default: () => [],
    },
    shipFilterEnabled: {
      type: Boolean,
      default: false,
    },
    shipColors: {
      type: Object,
      default: () => ({}),
    },
    scaleFactor: {
      type: Number,
      default: 1.0,
    },
    measureEnabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      activeIndex: 0,
      mouseX: 0,
      mouseXOnRail: 0
    };
  },
  mixins: [multiParkManagementMixins, convoyVisualizationMixins],
  mounted() {},
  computed: {
    maxRailLength() {
      const maxLengthRail = _.maxBy(this.binari, (b) => {
        return b.lunghezza;
      });
      return maxLengthRail && maxLengthRail.lunghezza ? maxLengthRail.lunghezza : 0;
    },
    carriConvoglio() {
      let carriConvoglio = [];
      this.convogli.forEach((convoglio) => {
        if (convoglio.listCarri) {
          let pos = convoglio.posizioneBinario;
          convoglio.listCarri = this._.orderBy(convoglio.listCarri, [(cc) => cc.posizione]);
          convoglio.listCarri.forEach((cc) => {
            cc.dialog = false;
            cc.posizioneBinario = pos;
            cc.idConvoglio = convoglio.id;
            pos += this.getCarroLength(cc);
            carriConvoglio.push(cc);
          });
        }
      });
      return carriConvoglio;
    },
    selectedAttributeValue() {
      if (this.selected) {
        return true;
      }
      return false;
    },
    convogliInLavorazione() {
      var convogliInLavorazione = [];
      this.convogli.forEach((convoglio) => {
        if (convoglio.listCarri && convoglio.listCarri.length > 0) {
          let hasCaricato = false;
          let hasScaricato = false;

          convoglio.listCarri.forEach((carro) => {
            if (Array.isArray(carro.listUti)) {
              carro.listUti.forEach((uti) => {
                if (uti.stato === "CARICATO") hasCaricato = true;
                if (uti.stato === "SCARICATO") hasScaricato = true;
              });
            }
          });
          // console.log("totalUti:", hasCaricato, "loadedOrUnloaded:", hasScaricato);
          if (hasCaricato && hasScaricato) {
            convogliInLavorazione.push(convoglio.id);
          }
        }
      });
      return convogliInLavorazione;
    },
  },
  methods: {
    // selectingRail() {
    //   this.$eventBus.$emit("selectingRail", this.binario.id);
    // },
    updateMousePosition(event) {
      if (this.measureEnabled && this.$refs["container" + this.binario.numero]) {
        const rect = this.$refs["container" + this.binario.numero].getBoundingClientRect();
        this.mouseX = Math.round(event.clientX - rect.left);
        this.mouseXOnRail = Math.round((this.binario.lunghezza * this.mouseX) / rect.width);
        if (this.parkPosition === "DX") {
          this.mouseXOnRail = this.binario.lunghezza - this.mouseXOnRail;
        }
        this.$emit("mouseMoveOnRail", { lineLeft: this.mouseX, railDivLeft: rect.left, mouseXOnRail: this.mouseXOnRail, width: rect.width });
        this.$emit("lineVisible", true);
      }
    },
    hideLine() {
      this.$emit("lineVisible", false);
    },
  },
};
</script>

<style scoped>
.rail-row {
  z-index: 1;
  height: 40px;
  position: relative;
}

.rail {
  z-index: 3;
  position: absolute;
  height: 40px;
  margin-top: 20px;
  border: 2px solid #e0e0e0;
  background-color: #f5f5f5;
  background-image: repeating-linear-gradient(45deg, #eeeeee, #eeeeee 10px, #f5f5f5 10px, #f5f5f5 20px);
}

/* .rail[selected="selected"] {
  background: #d3d3d3;
} */

.wagon {
  position: absolute;
  height: 40px;
  margin-top: 20px;
  border-right: 2px dashed #1b1b0f;
  background: rgba(105, 105, 105, 0.5);
  overflow: visible;
}
</style>
